export default {
  allActivityDetails: (state) => state.activityDetails
}
